import http from '../../http-common-admin';
import httptudents from '../../http-common-students';

    export const utilisateurFsvorisGetAll = (userID, typeUser) =>{

        return http.get(`/utilisateursFavoris?userID=${userID}&typeUser=${typeUser}`);

    }


    export const utilisateurFsvorisGetAllStudents = (userID, typeUser) =>{

        return httptudents.get(`/utilisateursFavoris?userID=${userID}&typeUser=${typeUser}`);

    }

    export const utilisateurFsvorisEnregistrer = (data) =>{
        return  http.post("/utilisateursFavoris", data);
    }


    export const utilisateurFsvorisDelete = (id) =>{
        return http.delete(`/utilisateursFavoris/${id}`)
    }

